import React from 'react'

const LocaleContext = React.createContext({ locale: 'ka', setLocale: () => {} })

export default LocaleContext

export const translationStore = {}
